module.exports = __webpack_public_path__ + "img/icon-bill-big-blue.de6b31e3.svg";